/**
 * Modify this file according to your environment.
 *
 * For dev, create environment.dev.js
 * for prod, create environment.prod.js
 *
 * Note: When creating new environmet variables
 * always make sure to follow the ff: format:
 * AC66_MY_ENVIRONMENT_VARIABLE_HERE
 * Don't forget to include the new variable in
 * deployer's script.
 */

const environment = {
  API_URL: '$AC66_AMS_API_URL',
  MOBILE_SITE_REDIRECT_URL: '$AC66_MOBILE_SITE_REDIRECT_URL',
  WEBSOCKET_URL: '$AC66_WEBSOCKET_URL',
  REALM: '$AC66_REALM',
  ASIANCONNECT_URL: '$AC66_ASIANCONNECT_URL',
  IDLE_TIMEOUT: '$AC66_IDLE_TIMEOUT',
  ECOPAYZ_SUCCESS_URL: '$AC66_ECOPAYZ_SUCCESS_URL',
  ECOPAYZ_FAILURE_URL: '$AC66_ECOPAYZ_FAILURE_URL',
  ECOPAYZ_CANCELATION_URL: '$AC66_ECOPAYZ_CANCELATION_URL',
  AES_ENCRYPTION_KEY: '$AC66_AES_ENCRYPTION_KEY',
  FRESH_CHAT_TOKEN: '$AC66_FRESH_CHAT_TOKEN',
  FRESH_CHAT_HOST: '$AC66_FRESH_CHAT_HOST',
  ZENDESK_WIDGET_SCRIPT: '$AC66_ZENDESK_WIDGET_SCRIPT'
};

export default environment;



// WEBPACK FOOTER //
// ./client/environments/environment.prod.js